<template>
  <main id="main" class="bg_gradient_theme_to_bottom d-flex flex-column justify-content-between position-relative">
    <div>
      <img src="@/assets/imgs/splash.png" class="w-100 mt-3" alt="">
      <p class="text-center text_color_white font_large mb-3">آینده من</p>
      <p class="text-center text_color_white font_large px-3">
        اولین اپلیکیشن فارسی دری آموزشی برای آماده سازی شاگردان به امتحانات بین المللی از طریق GED و SAT
      </p>
    </div>

    <div class="w-100 text-center pb-5 mb-4">
      <p class="text_color_white bold font_medium">{{ localVersion }}</p>
      <div
          v-if="loading"
          class="spinner-border text-light mt-2"
          role="status"
          style="width: 1.5rem; height: 1.5rem; border-width: 0.2em;"
      ></div>
    </div>

    <div v-if="showUpdateModal" class="modal_overlay">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box text-center animate_fade_in">
        <div class="d-flex justify-content-center mb-4">
          <div class="icon_circle_update">
            <img
                src="@/assets/imgs/rocket.svg"
                class="icon-size-4"
                alt=""
                @error="$event.target.src = require('@/assets/imgs/info-sign.png')"
            >
          </div>
        </div>
        <p class="text_color_theme bold font_large mb-3">آپدیت جدید</p>
        <p class="font_normal text_color_gray mb-4 line_height_2">
          ورژن جدید اپلیکیشن منتشر شده است.<br>
          برای دانلود به لینک زیر مراجعه کنید:
        </p>
        <a href="https://app.ayendaman.org/" target="_blank" class="button w-100 text-decoration-none d-block py-3">
          دانلود نسخه جدید
        </a>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'SplashView',
  data() {
    return {
      localVersion: '1.0.0',
      showUpdateModal: false,
      loading: true,
      minSplashTime: 3000
    }
  },
  mounted() {
    this.checkAppVersion()
  },
  methods: {
    // ✅ مسیر بعد از اسپلش بر اساس لوکال
    goNext() {
      const userId = localStorage.getItem('user_id')
      const role = localStorage.getItem('user_role') // 'student' | 'teacher'

      // اگر لاگین هست
      if (userId) {
        if (role === 'teacher') {
          return this.$router.replace({ name: 'TeacherHome' })
        }
        return this.$router.replace({ name: 'Home' })
      }

      // اگر لاگین نیست
      return this.$router.replace({ name: 'Language' })
    },

    async checkAppVersion() {
      const startTime = Date.now()

      const finishWithDelay = (cb) => {
        const elapsedTime = Date.now() - startTime
        const remainingTime = Math.max(0, this.minSplashTime - elapsedTime)
        setTimeout(() => {
          this.loading = false
          cb()
        }, remainingTime)
      }

      try {
        const formData = createFormData({ action: 'version_user' })
        const response = await apiClient.post('/public_info', formData)

        let serverData = null

        if (response.data) {
          if (response.data.version) {
            serverData = response.data
          } else if (response.data.data) {
            if (typeof response.data.data === 'string' && !response.data.data.startsWith('{')) {
              serverData = Decryption(response.data.data)
            } else {
              serverData = response.data.data
            }
          }
        }

        // اگر ورژن جدید بود => مودال
        if (serverData && serverData.version) {
          if (this.compareVersions(serverData.version, this.localVersion) > 0) {
            // اینجا دیگه تایمر اسپلش لازم نیست
            this.loading = false
            this.showUpdateModal = true
            return
          }
        }

        // در غیر اینصورت => بعد از زمان اسپلش برو مسیر درست
        finishWithDelay(() => this.goNext())

      } catch (error) {
        // خطا هم => بعد از زمان اسپلش برو مسیر درست
        finishWithDelay(() => this.goNext())
      }
    },

    compareVersions(v1, v2) {
      if (!v1 || !v2) return 0

      const v1Parts = v1.split('.').map(Number)
      const v2Parts = v2.split('.').map(Number)

      for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
        const val1 = v1Parts[i] || 0
        const val2 = v2Parts[i] || 0

        if (val1 > val2) return 1
        if (val1 < val2) return -1
      }

      return 0
    }
  }
}
</script>

<style scoped>
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_content {
  width: 85%;
  max-width: 24rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.animate_fade_in {
  animation: fadeIn 0.4s ease-out forwards;
}

.icon_circle_update {
  width: 6rem;
  height: 6rem;
  background: #f0f3ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 25px rgba(74, 0, 224, 0.15);
}

.line_height_2 {
  line-height: 1.8rem;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>
